module.exports = __webpack_public_path__ + "img/pictoEstablishementsCommon4.e9230c5e.svg";